import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, Button, Menu, Segment, Label, Dropdown, Checkbox, Grid, Icon } from 'semantic-ui-react';
import {
  SikdaeGroup,
  SikdaePolicy,
  Store,
  DateForm,
  Division,
  Time,
  Pagerow,
  Pagination,
  StatusList,
  DateType }
from './Commons';

const propTypes = {
};

const defaultProps = {
};

class FormBox extends Component {

  constructor(props) {
    super(props);

    this.state = {
      //페이징
      page : 1,
      pagerow : 10
    }
  }

  pageClick = async(page) => {
    await this.setState({ page : page });
  }

  handleChange = (e, {name, value}) => this.setState({ [name] : value });


  render() {
    const { page, pagerow } = this.state;
    const { FormBoxObj } = this.props;
    const friendOptions = [
      { text: 'Jenny Hess1', value: 'Jenny Hess1' }
      , { text: 'Jenny Hess2', value: 'Jenny Hess2' , disabled: true}
      , { text: 'Jenny Hess3', value: 'Jenny Hess3' , disabled: true}
      , { text: 'Jenny Hess4', value: 'Jenny Hess4' }
      , { text: 'Jenny Hess5', value: 'Jenny Hess5' }
    ]

    return(
      <Form className="attached fluid segment" style={{"marginBottom" : "300px"}}>
        <SikdaeGroup
          sikdaeGroup={FormBoxObj.sikdaeGroup}
          sikdaeGroupSearch={FormBoxObj.sikdaeGroupSearch}
        />
        <SikdaePolicy
          sikdaeGroupVal={FormBoxObj.sikdaeGroupVal}
          sikdaePolicy={FormBoxObj.sikdaePolicy}
        />
        <Store
          companyStore={FormBoxObj.companyStore}
        />
        <DateForm />
        <Division
          division={FormBoxObj.division}
        />
        <Time 
          timeType="sTime" 
          placeholder={'HH:mm'}
          isShowSecond={false}
          isShowMinute={true}
        />~
        <Time 
          timkType="eTime" 
          placeholder={'HH:mm'}
          isShowSecond={false}
          isShowMinute={true}
        />
        <StatusList
          sikStatus={FormBoxObj.sikStatus}
        />
        <Pagerow
        />
        <Pagination
          page={page}
          pageRow={pagerow}
          pageBlock={10}
          totalCount={111}
          pageClick={this.pageClick}
        />
        <DateType />
        <Form.Field>
          <Button color='blue'>Blue</Button>
          <Button inverted color='blue'>Blue</Button>
          <Button inverted color='grey'>Grey</Button>
          <Button color='green'>Green</Button>
          <Button inverted color='green'>Green</Button>
          <Button color='black'>Green</Button>
          <Button inverted color='black'>BLACK</Button>
          <Button inverted color='red'>Red</Button>
          <Button disabled>Disabled</Button>
        </Form.Field>
        <Form.Field>
          <div>
            <Menu fluid widths={4} tabular className="vendysFullTab" attached='top'>
              <Menu.Item active>
                <span>bio</span>
              </Menu.Item>
              <Menu.Item>
                <span>Photos</span>
              </Menu.Item>
              <Menu.Item>
                <span>bio</span>
              </Menu.Item>
              <Menu.Item>
                <span>Photos</span>
              </Menu.Item>
            </Menu>
            <Segment attached='bottom'>
              <h3>vendys full tab </h3>
            </Segment>
          </div>
          <br></br>
          <div>
            <Menu tabular className="vendysLeftTab" attached='top'>
              <Menu.Item>
                <span>bio</span>
              </Menu.Item>
              <Menu.Item active>
                <span>bio</span>
              </Menu.Item>
              <Menu.Item>
                <span>Photos</span>
              </Menu.Item>
              <Menu.Item>
                <span>Photos</span>
              </Menu.Item>
            </Menu>
            <Segment attached='bottom'>
              <h3>vendys left tab </h3>
            </Segment>
          </div>
        </Form.Field>
        <Form.Field>
          <Menu vertical className="vendysLeftMenu">
            <Menu.Item className="top" name='title'>
              title
            </Menu.Item>
            <Menu.Item name='inbox' active >
              <Label>1</Label>
              Inbox
            </Menu.Item>
            <Menu.Item name='spam'>
              <Label>51</Label>
              Spam
            </Menu.Item>
            <Menu.Item name='updates'>
              <Label>1</Label>
              Updates
            </Menu.Item>
          </Menu>
        </Form.Field>
        <Form.Group>
            <Dropdown
              placeholder='Select Friend'
              selection
              options={friendOptions} />
        </Form.Group>

        <Form.Field>
          <Grid.Column>
            <Checkbox label='checkbox1' />
          </Grid.Column>
          <Grid.Column>
            <Checkbox label='checkbox2' />
          </Grid.Column>
          <Grid.Column>
            <Checkbox label='checkbox3' disabled checked/>
          </Grid.Column>
          <Grid.Column>
            <div className="ui vendys">
              <input className="vendys-checkbox" id="vendys-checkbox" type="checkbox"/>
              <label for="vendys-checkbox"></label>
            </div>
          </Grid.Column>
        </Form.Field>

        <Form.Field>
          <Grid.Column>
            <Checkbox radio label='Radio choice1' />
          </Grid.Column>
          <Grid.Column>
            <Checkbox radio label='Radio choice2' />
          </Grid.Column>
          <Grid.Column>
            <Checkbox radio label='Radio choice3' disabled checked/>
          </Grid.Column>
        </Form.Field>
      </Form>
    );
  }
}

FormBox.propTypes = propTypes;
FormBox.defaultProps = defaultProps;

export default FormBox;
